import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { HowItWorks } from "@/components/HowItWorks";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { CookieConsent } from "@/components/CookieConsent";
import { MobileContactButton } from "@/components/MobileContactButton";

const Index = () => {
  return (
    <>
      <Header />
      <main id="main-content">
        <Hero />
        <Services />
        <HowItWorks />
        <About />
        <Contact />
      </main>
      <Footer />
      <CookieConsent />
      <MobileContactButton />
    </>
  );
};

export default Index;